import React, { Component } from "react";

export default class CloudInfraImg extends Component {
  render() {
    const theme = this.props.theme;
    const primary = theme.imageHighlight || "#0E6BA8";
    const accent = theme.headerColor || "#0E6BA877";
    const surface = theme.body || "#ffffff";
    const ink = theme.text || "#001C55";

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="80%"
        height="auto"
        viewBox="0 0 500 400"
        fill="none"
        aria-label="Shipping and DevOps pipeline"
      >
        <ellipse cx="250" cy="370" rx="180" ry="14" fill={accent} opacity="0.4" />

        {/* Cloud */}
        <g transform="translate(250,90)">
          <ellipse cx="-30" cy="0" rx="28" ry="18" fill={primary} opacity="0.65" />
          <ellipse cx="0" cy="-8" rx="36" ry="24" fill={primary} opacity="0.85" />
          <ellipse cx="32" cy="0" rx="28" ry="18" fill={primary} opacity="0.65" />
          <rect x="-60" y="0" width="120" height="20" rx="10" fill={primary} opacity="0.85" />
        </g>

        {/* Pipeline stages */}
        <g transform="translate(60,200)">
          {/* Build */}
          <g>
            <rect width="80" height="60" rx="12" fill={primary} opacity="0.95" />
            <text x="40" y="34" textAnchor="middle" fontSize="13" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>BUILD</text>
            <text x="40" y="50" textAnchor="middle" fontSize="9" fontFamily="Helvetica, sans-serif" fill={surface} opacity="0.85">Tuist · SPM</text>
          </g>
          <line x1="84" y1="30" x2="106" y2="30" stroke={primary} strokeWidth="3" strokeLinecap="round" />
          <polygon points="106,24 116,30 106,36" fill={primary} />

          {/* Test */}
          <g transform="translate(120,0)">
            <rect width="80" height="60" rx="12" fill={primary} opacity="0.85" />
            <text x="40" y="34" textAnchor="middle" fontSize="13" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>TEST</text>
            <text x="40" y="50" textAnchor="middle" fontSize="9" fontFamily="Helvetica, sans-serif" fill={surface} opacity="0.85">XCTest · TDD</text>
          </g>
          <line x1="204" y1="30" x2="226" y2="30" stroke={primary} strokeWidth="3" strokeLinecap="round" />
          <polygon points="226,24 236,30 226,36" fill={primary} />

          {/* Sign */}
          <g transform="translate(240,0)">
            <rect width="80" height="60" rx="12" fill={primary} opacity="0.7" />
            <text x="40" y="34" textAnchor="middle" fontSize="13" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>SIGN</text>
            <text x="40" y="50" textAnchor="middle" fontSize="9" fontFamily="Helvetica, sans-serif" fill={surface} opacity="0.85">Fastlane</text>
          </g>
          <line x1="324" y1="30" x2="346" y2="30" stroke={primary} strokeWidth="3" strokeLinecap="round" />
          <polygon points="346,24 356,30 346,36" fill={primary} />

          {/* Ship */}
          <g transform="translate(360,0)">
            <rect width="80" height="60" rx="12" fill={ink} />
            <text x="40" y="34" textAnchor="middle" fontSize="13" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>SHIP</text>
            <text x="40" y="50" textAnchor="middle" fontSize="9" fontFamily="Helvetica, sans-serif" fill={surface} opacity="0.85">App Store</text>
          </g>
        </g>

        {/* Rocket */}
        <g transform="translate(250,290)">
          <path
            d="M0,-40 C-12,-30 -18,-12 -18,4 L-18,18 L18,18 L18,4 C18,-12 12,-30 0,-40 Z"
            fill={primary}
          />
          <circle cx="0" cy="-10" r="6" fill={surface} />
          <path d="M-18,4 L-30,16 L-18,18 Z" fill={primary} opacity="0.7" />
          <path d="M18,4 L30,16 L18,18 Z" fill={primary} opacity="0.7" />
          <path d="M-8,18 L0,40 L8,18 Z" fill="#FF9500" opacity="0.95" />
          <path d="M-4,18 L0,32 L4,18 Z" fill="#FFCC00" />
        </g>

        {/* Status pill */}
        <g transform="translate(60,80)">
          <rect width="86" height="28" rx="14" fill="#34C759" />
          <circle cx="14" cy="14" r="4" fill={surface} />
          <text x="50" y="19" textAnchor="middle" fontSize="11" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>PASSED</text>
        </g>

        {/* Status pill 2 */}
        <g transform="translate(360,80)">
          <rect width="80" height="28" rx="14" fill={primary} />
          <text x="40" y="19" textAnchor="middle" fontSize="11" fontFamily="Helvetica, sans-serif" fontWeight="700" fill={surface}>v1.4.2</text>
        </g>
      </svg>
    );
  }
}
